
/**
 * APIService.js contains a central service for connecting with the ARIA API.
 * It depends on axios and axios-retry.
 *
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */
 import * as retry from 'axios-retry';
 import * as axios from 'axios';
 import store from '@/store/store.js';

 const headerConfigs = (config) => {
     config.headers = {
         Accept: 'application/json',
         'Content-Type': 'application/json',
         'Authorization': store.getters.getLoggedInUserIdToken
     };
     return config;
 }
 
 const apiClient = axios.create({
     baseURL: process.env.VUE_APP_API,
     withCredentials: false, // This is the default
     timeout: 15000,
 });
 apiClient.interceptors.request.use(headerConfigs);

 const apiAuthClient = axios.create({
    baseURL: process.env.VUE_APP_AUTH_API,
    withCredentials: false,
    timeout: 15000
 });
 apiAuthClient.interceptors.request.use(headerConfigs);

 
 retry(apiClient, {
     retries: 3,
     retryDelay: retry.exponentialDelay
 });
 
 retry(apiAuthClient, {
     retries: 3,
     retryDelay: retry.exponentialDelay
 });
 
 export default {
     name: 'call',
     /**
      * Call the ARIA API
      * @param {String} url - the URL of the specific endpoint to call
      * @param {Object} params
      * @param {String} params.method - HTTP method to use for call
      * @returns a promise with the API payload
      */
     call(url, { method = 'post', ...otherParams}, api) {
        let thisClient;
        switch(api){
            case "Auth":
                thisClient = apiAuthClient;
                break;
            default:
                thisClient = apiClient;
                break;
        }
         // check if auth token expired
         if (!store.getters.getLoggedInUserIdToken || store.getters.getAccessTokenExpiration - Date.now() < 0) {
             console.error("No valid token found! Logging out");
             store.dispatch('logout');
             return;
         }
         return thisClient.request({
             method,
             url,
             data: otherParams
         }).catch(error => {
             // Global error handling done here
 
             throw (error);
         });
     },
 };